import { IProgramFunction } from "./program_function";

export enum ComponentMethod {
    AND = "AND",
    OR = "or",
    NOT = "not",
    NAND = "nand",
    NOR = "nor",
    XOR = "xor",
};

export interface IComponent {
    id?: number;
    program_id?: number;
    description: string;
    method: ComponentMethod;
    program_functions: IProgramFunction[];
};